import { colors, fontSize, size } from '@styles/theme'
import styled from '@emotion/styled'

import { PiPaperPlaneRightBold } from 'react-icons/pi'
import { ButtonBase } from '@mui/material'

const sendButtonHeight = size(6)
const sendButtonBottom = size(0.5)

const SendButton = styled(ButtonBase)`
  position: absolute;
  z-index: 10000000;
  transform: translateX(-50%);
  left: 50%;
  bottom: ${sendButtonBottom};
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${sendButtonHeight};
  padding: 0 ${size(3)};
  width: calc(100dvw - ${size(3)});
  background-color: ${colors.statusColors.right_now('primary')};
  text-shadow: 0 1px 4px #333333CC;
  font-weight: 600;
  font-size: ${fontSize('lg')};
  border-radius: 100px;
  svg {
    filter: drop-shadow(0 1px 2px #333333CC);
  }
`

const UserMediaSendButton = ({ isMediaSelected, disabled, onClick }) => {
  if (!isMediaSelected) return;
  return (
    <SendButton 
      style={disabled && { backgroundColor: colors.statusColors.right_now('light') } || {}}
      disabled={disabled}
      onClick={onClick}>
      Send Media&nbsp;<PiPaperPlaneRightBold />
    </SendButton>
  )
}

export { UserMediaSendButton }
